import { render, staticRenderFns } from "./TtsReaderElement.vue?vue&type=template&id=7f791058&scoped=true&"
import script from "./TtsReaderElement.vue?vue&type=script&lang=ts&"
export * from "./TtsReaderElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f791058",
  null
  
)

export default component.exports